import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { Observable } from 'rxjs';
import { DocumentUrlWithKey } from '../../../store/reducer/document.reducer';

export type LogoDialogResultAction = 'upload' | 'delete';

export interface LogoDialogResult {
    action: LogoDialogResultAction;
    file?: File;
}

export interface LogoDialogData {
    logo$: Observable<DocumentUrlWithKey>;
}

@Component({
    standalone: false,
    selector: 'app-logo-dialog',
    templateUrl: './logo-dialog.component.html'
})
export class LogoDialogComponent {
    localLogo$: Observable<DocumentUrlWithKey>;
    selectedLogoFile: File;
    previewImageSrc: string | ArrayBuffer | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: LogoDialogData,
        private dialogRef: MatDialogRef<LogoDialogComponent>
    ) {
        this.localLogo$ = data.logo$;
    }

    onLogoSelect(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input?.files && input.files.length > 0) {
            this.selectedLogoFile = input.files[0];

            const reader = new FileReader();
            reader.onload = () => {
                this.previewImageSrc = reader.result;
            };
            reader.readAsDataURL(this.selectedLogoFile);
        }
    }

    save(): void {
        if (this.selectedLogoFile) {
            const result: LogoDialogResult = { action: 'upload', file: this.selectedLogoFile };
            this.dialogRef.close(result);
        }
    }

    deleteLogo(): void {
        const result: LogoDialogResult = { action: 'delete' };
        this.dialogRef.close(result);
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }
}
